import { render, staticRenderFns } from "./ImpersonationBanner.vue?vue&type=template&id=b1d8dc42&"
import script from "./ImpersonationBanner.vue?vue&type=script&lang=js&"
export * from "./ImpersonationBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports